import { render, staticRenderFns } from "./ControlsCom.vue?vue&type=template&id=7dca62e0&scoped=true"
import script from "./ControlsCom.vue?vue&type=script&lang=js"
export * from "./ControlsCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dca62e0",
  null
  
)

export default component.exports